export default __webpack_public_path__ + "static/media/vietnam.7583a6db.mp3";